.Stack {
  display: flex;
}

/*
 * Direction
 */
.Stack--vertical {
  flex-direction: column;
}

.Stack--horizontal {
  flex-direction: row;
}

.Stack-narrow--vertical {
  flex-direction: column;
}

.Stack-narrow--horizontal {
  flex-direction: row;
}

@media screen and (min-width: 48rem) {
  .Stack-regular--vertical {
    flex-direction: column;
  }

  .Stack-regular--horizontal {
    flex-direction: row;
  }
}

@media screen and (min-width: 80rem) {
  .Stack-wide--vertical {
    flex-direction: column;
  }

  .Stack-wide--horizontal {
    flex-direction: row;
  }
}

/*
 * Gap and padding
 */
.Stack--gap-none {
  gap: 0;
}

.Stack--gap-condensed {
  gap: var(--brand-stack-gap-condensed);
}

.Stack--gap-normal {
  gap: var(--brand-stack-gap-normal);
}

.Stack--gap-spacious {
  gap: var(--brand-stack-gap-spacious);
}

.Stack--gap-4 {
  gap: var(--base-size-4);
}
.Stack--gap-8 {
  gap: var(--base-size-8);
}
.Stack--gap-12 {
  gap: var(--base-size-12);
}
.Stack--gap-16 {
  gap: var(--base-size-16);
}
.Stack--gap-20 {
  gap: var(--base-size-20);
}
.Stack--gap-24 {
  gap: var(--base-size-24);
}
.Stack--gap-28 {
  gap: var(--base-size-28);
}
.Stack--gap-32 {
  gap: var(--base-size-32);
}
.Stack--gap-36 {
  gap: var(--base-size-36);
}
.Stack--gap-40 {
  gap: var(--base-size-40);
}
.Stack--gap-44 {
  gap: var(--base-size-44);
}
.Stack--gap-48 {
  gap: var(--base-size-48);
}
.Stack--gap-60 {
  gap: var(--base-size-60);
}
.Stack--gap-64 {
  gap: var(--base-size-64);
}
.Stack--gap-80 {
  gap: var(--base-size-80);
}
.Stack--gap-88 {
  gap: var(--base-size-88);
}
.Stack--gap-96 {
  gap: var(--base-size-96);
}
.Stack--gap-112 {
  gap: var(--base-size-112);
}
.Stack--gap-128 {
  gap: var(--base-size-128);
}

.Stack-narrow--gap-none {
  gap: 0;
}

.Stack-narrow--gap-condensed {
  gap: var(--brand-stack-gap-condensed);
}

.Stack-narrow--gap-normal {
  gap: var(--brand-stack-gap-normal);
}

.Stack-narrow--gap-spacious {
  gap: var(--brand-stack-gap-spacious);
}

.Stack--padding-none {
  padding: 0;
}

.Stack--padding-condensed {
  padding: var(--brand-stack-padding-condensed);
}

.Stack--padding-normal {
  padding: var(--brand-stack-padding-normal);
}

.Stack--padding-spacious {
  padding: var(--brand-stack-padding-spacious);
}

.Stack--padding-4 {
  padding: var(--base-size-4);
}
.Stack--padding-8 {
  padding: var(--base-size-8);
}
.Stack--padding-12 {
  padding: var(--base-size-12);
}
.Stack--padding-16 {
  padding: var(--base-size-16);
}
.Stack--padding-20 {
  padding: var(--base-size-20);
}
.Stack--padding-24 {
  padding: var(--base-size-24);
}
.Stack--padding-28 {
  padding: var(--base-size-28);
}
.Stack--padding-32 {
  padding: var(--base-size-32);
}
.Stack--padding-36 {
  padding: var(--base-size-36);
}
.Stack--padding-40 {
  padding: var(--base-size-40);
}
.Stack--padding-44 {
  padding: var(--base-size-44);
}
.Stack--padding-48 {
  padding: var(--base-size-48);
}
.Stack--padding-60 {
  padding: var(--base-size-60);
}
.Stack--padding-64 {
  padding: var(--base-size-64);
}
.Stack--padding-80 {
  padding: var(--base-size-80);
}
.Stack--padding-88 {
  padding: var(--base-size-88);
}
.Stack--padding-96 {
  padding: var(--base-size-96);
}
.Stack--padding-112 {
  padding: var(--base-size-112);
}
.Stack--padding-128 {
  padding: var(--base-size-128);
}

.Stack-narrow--padding-none {
  padding: 0;
}

.Stack-narrow--padding-condensed {
  padding: var(--brand-stack-padding-condensed);
}

.Stack-narrow--padding-normal {
  padding: var(--brand-stack-padding-normal);
}

.Stack-narrow--padding-spacious {
  padding: var(--brand-stack-padding-spacious);
}

.Stack-narrow--padding-4 {
  padding: var(--base-size-4);
}
.Stack-narrow--padding-8 {
  padding: var(--base-size-8);
}
.Stack-narrow--padding-12 {
  padding: var(--base-size-12);
}
.Stack-narrow--padding-16 {
  padding: var(--base-size-16);
}
.Stack-narrow--padding-20 {
  padding: var(--base-size-20);
}
.Stack-narrow--padding-24 {
  padding: var(--base-size-24);
}
.Stack-narrow--padding-28 {
  padding: var(--base-size-28);
}
.Stack-narrow--padding-32 {
  padding: var(--base-size-32);
}
.Stack-narrow--padding-36 {
  padding: var(--base-size-36);
}
.Stack-narrow--padding-40 {
  padding: var(--base-size-40);
}
.Stack-narrow--padding-44 {
  padding: var(--base-size-44);
}
.Stack-narrow--padding-48 {
  padding: var(--base-size-48);
}
.Stack-narrow--padding-60 {
  padding: var(--base-size-60);
}
.Stack-narrow--padding-64 {
  padding: var(--base-size-64);
}
.Stack-narrow--padding-80 {
  padding: var(--base-size-80);
}
.Stack-narrow--padding-88 {
  padding: var(--base-size-88);
}
.Stack-narrow--padding-96 {
  padding: var(--base-size-96);
}
.Stack-narrow--padding-112 {
  padding: var(--base-size-112);
}
.Stack-narrow--padding-128 {
  padding: var(--base-size-128);
}

.Stack-narrow--gap-4 {
  gap: var(--base-size-4);
}
.Stack-narrow--gap-8 {
  gap: var(--base-size-8);
}
.Stack-narrow--gap-12 {
  gap: var(--base-size-12);
}
.Stack-narrow--gap-16 {
  gap: var(--base-size-16);
}
.Stack-narrow--gap-20 {
  gap: var(--base-size-20);
}
.Stack-narrow--gap-24 {
  gap: var(--base-size-24);
}
.Stack-narrow--gap-28 {
  gap: var(--base-size-28);
}
.Stack-narrow--gap-32 {
  gap: var(--base-size-32);
}
.Stack-narrow--gap-36 {
  gap: var(--base-size-36);
}
.Stack-narrow--gap-40 {
  gap: var(--base-size-40);
}
.Stack-narrow--gap-44 {
  gap: var(--base-size-44);
}
.Stack-narrow--gap-48 {
  gap: var(--base-size-48);
}
.Stack-narrow--gap-60 {
  gap: var(--base-size-60);
}
.Stack-narrow--gap-64 {
  gap: var(--base-size-64);
}
.Stack-narrow--gap-80 {
  gap: var(--base-size-80);
}
.Stack-narrow--gap-88 {
  gap: var(--base-size-88);
}
.Stack-narrow--gap-96 {
  gap: var(--base-size-96);
}
.Stack-narrow--gap-112 {
  gap: var(--base-size-112);
}
.Stack-narrow--gap-128 {
  gap: var(--base-size-128);
}

@media screen and (min-width: 48rem) {
  .Stack-regular--gap-none {
    gap: 0;
  }

  .Stack-regular--gap-condensed {
    gap: var(--brand-stack-gap-condensed);
  }

  .Stack-regular--gap-normal {
    gap: var(--brand-stack-gap-normal);
  }

  .Stack-regular--gap-spacious {
    gap: var(--brand-stack-gap-spacious);
  }

  .Stack-regular--gap-4 {
    gap: var(--base-size-4);
  }
  .Stack-regular--gap-8 {
    gap: var(--base-size-8);
  }
  .Stack-regular--gap-12 {
    gap: var(--base-size-12);
  }
  .Stack-regular--gap-16 {
    gap: var(--base-size-16);
  }
  .Stack-regular--gap-20 {
    gap: var(--base-size-20);
  }
  .Stack-regular--gap-24 {
    gap: var(--base-size-24);
  }
  .Stack-regular--gap-28 {
    gap: var(--base-size-28);
  }
  .Stack-regular--gap-32 {
    gap: var(--base-size-32);
  }
  .Stack-regular--gap-36 {
    gap: var(--base-size-36);
  }
  .Stack-regular--gap-40 {
    gap: var(--base-size-40);
  }
  .Stack-regular--gap-44 {
    gap: var(--base-size-44);
  }
  .Stack-regular--gap-48 {
    gap: var(--base-size-48);
  }
  .Stack-regular--gap-60 {
    gap: var(--base-size-60);
  }
  .Stack-regular--gap-64 {
    gap: var(--base-size-64);
  }
  .Stack-regular--gap-80 {
    gap: var(--base-size-80);
  }
  .Stack-regular--gap-88 {
    gap: var(--base-size-88);
  }
  .Stack-regular--gap-96 {
    gap: var(--base-size-96);
  }
  .Stack-regular--gap-112 {
    gap: var(--base-size-112);
  }
  .Stack-regular--gap-128 {
    gap: var(--base-size-128);
  }

  .Stack-regular--padding-none {
    padding: 0;
  }

  .Stack-regular--padding-condensed {
    padding: var(--brand-stack-padding-condensed);
  }

  .Stack-regular--padding-normal {
    padding: var(--brand-stack-padding-normal);
  }

  .Stack-regular--padding-spacious {
    padding: var(--brand-stack-padding-spacious);
  }

  .Stack-regular--padding-4 {
    padding: var(--base-size-4);
  }
  .Stack-regular--padding-8 {
    padding: var(--base-size-8);
  }
  .Stack-regular--padding-12 {
    padding: var(--base-size-12);
  }
  .Stack-regular--padding-16 {
    padding: var(--base-size-16);
  }
  .Stack-regular--padding-20 {
    padding: var(--base-size-20);
  }
  .Stack-regular--padding-24 {
    padding: var(--base-size-24);
  }
  .Stack-regular--padding-28 {
    padding: var(--base-size-28);
  }
  .Stack-regular--padding-32 {
    padding: var(--base-size-32);
  }
  .Stack-regular--padding-36 {
    padding: var(--base-size-36);
  }
  .Stack-regular--padding-40 {
    padding: var(--base-size-40);
  }
  .Stack-regular--padding-44 {
    padding: var(--base-size-44);
  }
  .Stack-regular--padding-48 {
    padding: var(--base-size-48);
  }
  .Stack-regular--padding-60 {
    padding: var(--base-size-60);
  }
  .Stack-regular--padding-64 {
    padding: var(--base-size-64);
  }
  .Stack-regular--padding-80 {
    padding: var(--base-size-80);
  }
  .Stack-regular--padding-88 {
    padding: var(--base-size-88);
  }
  .Stack-regular--padding-96 {
    padding: var(--base-size-96);
  }
  .Stack-regular--padding-112 {
    padding: var(--base-size-112);
  }
  .Stack-regular--padding-128 {
    padding: var(--base-size-128);
  }
}

@media screen and (min-width: 80rem) {
  .Stack-wide--gap-none {
    gap: 0;
  }

  .Stack-wide--gap-condensed {
    gap: var(--brand-stack-gap-condensed);
  }

  .Stack-wide--gap-normal {
    gap: var(--brand-stack-gap-normal);
  }

  .Stack-wide--gap-spacious {
    gap: var(--brand-stack-gap-spacious);
  }

  .Stack-wide--gap-4 {
    gap: var(--base-size-4);
  }
  .Stack-wide--gap-8 {
    gap: var(--base-size-8);
  }
  .Stack-wide--gap-12 {
    gap: var(--base-size-12);
  }
  .Stack-wide--gap-16 {
    gap: var(--base-size-16);
  }
  .Stack-wide--gap-20 {
    gap: var(--base-size-20);
  }
  .Stack-wide--gap-24 {
    gap: var(--base-size-24);
  }
  .Stack-wide--gap-28 {
    gap: var(--base-size-28);
  }
  .Stack-wide--gap-32 {
    gap: var(--base-size-32);
  }
  .Stack-wide--gap-36 {
    gap: var(--base-size-36);
  }
  .Stack-wide--gap-40 {
    gap: var(--base-size-40);
  }
  .Stack-wide--gap-44 {
    gap: var(--base-size-44);
  }
  .Stack-wide--gap-48 {
    gap: var(--base-size-48);
  }
  .Stack-wide--gap-60 {
    gap: var(--base-size-60);
  }
  .Stack-wide--gap-64 {
    gap: var(--base-size-64);
  }
  .Stack-wide--gap-80 {
    gap: var(--base-size-80);
  }
  .Stack-wide--gap-88 {
    gap: var(--base-size-88);
  }
  .Stack-wide--gap-96 {
    gap: var(--base-size-96);
  }
  .Stack-wide--gap-112 {
    gap: var(--base-size-112);
  }
  .Stack-wide--gap-128 {
    gap: var(--base-size-128);
  }

  .Stack-wide--padding-none {
    padding: 0;
  }

  .Stack-wide--padding-condensed {
    padding: var(--brand-stack-padding-condensed);
  }

  .Stack-wide--padding-normal {
    padding: var(--brand-stack-padding-normal);
  }

  .Stack-wide--padding-spacious {
    padding: var(--brand-stack-padding-spacious);
  }

  .Stack-wide--padding-4 {
    padding: var(--base-size-4);
  }
  .Stack-wide--padding-8 {
    padding: var(--base-size-8);
  }
  .Stack-wide--padding-12 {
    padding: var(--base-size-12);
  }
  .Stack-wide--padding-16 {
    padding: var(--base-size-16);
  }
  .Stack-wide--padding-20 {
    padding: var(--base-size-20);
  }
  .Stack-wide--padding-24 {
    padding: var(--base-size-24);
  }
  .Stack-wide--padding-28 {
    padding: var(--base-size-28);
  }
  .Stack-wide--padding-32 {
    padding: var(--base-size-32);
  }
  .Stack-wide--padding-36 {
    padding: var(--base-size-36);
  }
  .Stack-wide--padding-40 {
    padding: var(--base-size-40);
  }
  .Stack-wide--padding-44 {
    padding: var(--base-size-44);
  }
  .Stack-wide--padding-48 {
    padding: var(--base-size-48);
  }
  .Stack-wide--padding-60 {
    padding: var(--base-size-60);
  }
  .Stack-wide--padding-64 {
    padding: var(--base-size-64);
  }
  .Stack-wide--padding-80 {
    padding: var(--base-size-80);
  }
  .Stack-wide--padding-88 {
    padding: var(--base-size-88);
  }
  .Stack-wide--padding-96 {
    padding: var(--base-size-96);
  }
  .Stack-wide--padding-112 {
    padding: var(--base-size-112);
  }
  .Stack-wide--padding-128 {
    padding: var(--base-size-128);
  }
}

/*
 * Vertical alignment
 */

.Stack--align-items-flex-end {
  align-items: flex-end;
}

.Stack--align-items-flex-start {
  align-items: flex-start;
}

.Stack--align-items-center {
  align-items: center;
}

.Stack-narrow--align-items-flex-end {
  align-items: flex-end;
}

.Stack-narrow--align-items-flex-start {
  align-items: flex-start;
}

.Stack-narrow--align-items-center {
  align-items: center;
}

@media screen and (min-width: 48rem) {
  .Stack-regular--align-items-flex-end {
    align-items: flex-end;
  }

  .Stack-regular--align-items-flex-start {
    align-items: flex-start;
  }

  .Stack-regular--align-items-center {
    align-items: center;
  }
}

@media screen and (min-width: 80rem) {
  .Stack-wide--align-items-flex-end {
    align-items: flex-end;
  }

  .Stack-wide--align-items-flex-start {
    align-items: flex-start;
  }

  .Stack-wide--align-items-center {
    align-items: center;
  }
}

/*
 * Horizontal alignment
 */

.Stack--justify-content-flex-end {
  justify-content: flex-end;
}

.Stack--justify-content-flex-start {
  justify-content: flex-start;
}

.Stack--justify-content-center {
  justify-content: center;
}

.Stack--justify-content-space-between {
  justify-content: space-between;
}

.Stack--justify-content-space-evenly {
  justify-content: space-evenly;
}

.Stack--justify-content-space-around {
  justify-content: space-around;
}

.Stack-narrow--justify-content-flex-end {
  justify-content: flex-end;
}

.Stack-narrow--justify-content-flex-start {
  justify-content: flex-start;
}

.Stack-narrow--justify-content-center {
  justify-content: center;
}

.Stack-narrow--justify-content-space-between {
  justify-content: space-between;
}

.Stack-narrow--justify-content-space-evenly {
  justify-content: space-evenly;
}

.Stack-narrow--justify-content-space-around {
  justify-content: space-around;
}

@media screen and (min-width: 48rem) {
  .Stack-regular--justify-content-flex-end {
    justify-content: flex-end;
  }

  .Stack-regular--justify-content-flex-start {
    justify-content: flex-start;
  }

  .Stack-regular--justify-content-center {
    justify-content: center;
  }

  .Stack-regular--justify-content-space-between {
    justify-content: space-between;
  }

  .Stack-regular--justify-content-space-evenly {
    justify-content: space-evenly;
  }

  .Stack-regular--justify-content-space-around {
    justify-content: space-around;
  }
}

@media screen and (min-width: 80rem) {
  .Stack-wide--justify-content-flex-end {
    justify-content: flex-end;
  }

  .Stack-wide--justify-content-flex-start {
    justify-content: flex-start;
  }

  .Stack-wide--justify-content-center {
    justify-content: center;
  }

  .Stack-wide--justify-content-space-between {
    justify-content: space-between;
  }

  .Stack-wide--justify-content-space-evenly {
    justify-content: space-evenly;
  }

  .Stack-wide--justify-content-space-around {
    justify-content: space-around;
  }
}

/*
 * Wrap
 */

.Stack-flexWrap--wrap {
  flex-wrap: wrap;
}

.Stack-flexWrap--no-wrap {
  flex-wrap: nowrap;
}

.Stack-narrow-flexWrap--wrap {
  flex-wrap: wrap;
}

.Stack-narrow-flexWrap--no-wrap {
  flex-wrap: nowrap;
}

@media screen and (min-width: 48rem) {
  .Stack-regular-flexWrap--wrap {
    flex-wrap: wrap;
  }

  .Stack-regular-flexWrap--no-wrap {
    flex-wrap: nowrap;
  }
}

@media screen and (min-width: 80rem) {
  .Stack-wide-flexWrap--wrap {
    flex-wrap: wrap;
  }

  .Stack-wide-flexWrap--no-wrap {
    flex-wrap: nowrap;
  }
}
